import { render, staticRenderFns } from "./ServicesHero.vue?vue&type=template&id=31c8b7e8&scoped=true&"
import script from "./ServicesHero.vue?vue&type=script&lang=js&"
export * from "./ServicesHero.vue?vue&type=script&lang=js&"
import style0 from "./ServicesHero.vue?vue&type=style&index=0&id=31c8b7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8b7e8",
  null
  
)

export default component.exports